import { APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { inject, NgModule } from '@angular/core';
import { ApolloClientOptions, from, InMemoryCache } from '@apollo/client/core';
import { environment } from 'src/infrastructure/environments/environment';
import { setContext } from '@apollo/client/link/context';
import { JwtService } from '../services/jwt.service';
import { createTokenAfterware } from './token-afterware';
import { CapacitorHttpLink } from './capacitor-http-link';
import { Capacitor } from '@capacitor/core';
//import { HttpHeaders } from '@angular/common/http';

export function createApollo(): ApolloClientOptions<any> {
  const httpLink = inject(HttpLink);
  const jwtService = inject(JwtService);

  // Auth middleware link
  const authLink = setContext((operation, { headers }) => {
    // Get the authentication token from localStorage
    const token = jwtService.getToken();
    
    // Operaciones que NO requieren autenticación
    const publicOperations = [
      'CreateUser', 
      'LoginUser', 
      'RecoverPassword', 
      'NewPassword',
      'GetMunicipalities',
      'GetUserLocationData',
      'GetSchedulesBySectorWithStatusActive',
      'GetNewsList'
    ];
    const operationName = operation.operationName;
    
    //console.log('🔍 DEBUGGING Apollo - Operation:', operationName);
    //console.log('🔍 DEBUGGING Apollo - Has token:', !!token);
    //console.log('🔍 DEBUGGING Apollo - Is public operation:', publicOperations.includes(operationName || ''));

    // Para operaciones públicas, no enviar token de autorización
    if (publicOperations.includes(operationName || '')) {
      //console.log('🔍 DEBUGGING Apollo - Sending request WITHOUT authorization header');
      return {
        headers: {
          ...headers,
          // No Authorization header for public operations
        }
      };
    }

    // Para operaciones privadas, enviar token si existe
    //console.log('🔍 DEBUGGING Apollo - Sending request WITH authorization header');
    return {
      headers: {
        ...headers,
        Authorization: token ? `Bearer ${token}` : '',
      }
    };
  });

  // Token afterware to save tokens from responses
  const tokenAfterware = createTokenAfterware(jwtService);

  // Use Capacitor HTTP link for native platforms, regular HttpLink for web
  const baseLink = Capacitor.isNativePlatform() 
    ? new CapacitorHttpLink(environment.graphqlUrl)
    : httpLink.create({ uri: environment.graphqlUrl });

  // Combine the links
  const link = from([authLink, tokenAfterware, baseLink]);

  return {
    link,
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'network-only',
        errorPolicy: 'all',
      },
      query: {
        fetchPolicy: 'network-only',
        errorPolicy: 'all',
      },
    },
  };
}

export class GraphQLModule { }
